<div class="dialog-container">
  <div class="message">
    {{selectPage}}
  </div>

  <div class="gif-container">
    <video autoplay loop>
      <source src="assets/gif_info.mp4" type="video/mp4">
      {{browserProblemAdvise}}
    </video>
  </div>

  <div class="button-container">
    <button mat-raised-button color="primary" (click)="closeDialog()">Continuă</button>
  </div>
</div>

